import styles from "./YearSelector.module.css";

function YearSelector({ year, setYear }) {
	return (
		<div className={styles.yearSelect}>
			<select
				value={year}
				onChange={(e) => setYear(e.target.value)}
			>
				<option value="25">2025</option>
				<option value="26">2026</option>
			</select>
		</div>
	);
}

export default YearSelector;
